import autoTable from 'jspdf-autotable';
import { calcDeduzioneNottePassiva, overlapsPassiveWindow, parseNotteAttivaIntervalli } from '../components/Turni/nottePassiva';
import { ABSENCE_TYPES, fmt, italianWeekday, fmtDuration } from './turniPdfHelpers';

export const renderPageHeader = (doc, uName, periodo, today, pageW) => {
  doc.setFillColor(41, 128, 185);
  doc.rect(0, 0, pageW, 14, 'F');
  doc.setTextColor(255);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text('Casa Letizia — Resoconto Mensile Turni', 14, 9);
  doc.setTextColor(0);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(12);
  doc.text(`Collaboratore: ${uName}`, 14, 24);
  doc.setFontSize(10);
  doc.setTextColor(80);
  doc.text(`Mese: ${periodo}`, 14, 31);
  doc.text(`Generato il: ${today}`, 14, 37);
  doc.setTextColor(0);
};

export const buildSaldoCell = (saldo) =>
  saldo === null
    ? { content: '—', styles: { halign: 'center' } }
    : { content: `${saldo >= 0 ? '+' : ''}${saldo}h`, styles: { halign: 'center', fontStyle: 'bold', textColor: saldo >= 0 ? [0, 128, 0] : [180, 0, 0] } };

export const renderStatsTable = (doc, stats, oreEffettive, saldoCell) => {
  autoTable(doc, {
    startY: 44,
    head: [['Contratto', 'Assegnate', 'Svolte', 'Straord.', 'Ferie', 'Permessi', 'Malattia', 'Infortunio', 'Reperibilità', 'Effettive', 'Debito/Accredito']],
    body: [[`${stats.oreMensiliContratto}h`, `${stats.expectedHours}h`, `${stats.workedHours}h`, `${stats.overtimeHours}h`, `${stats.ferieHours}h`, `${stats.permessiHours}h`, `${stats.malattiaHours}h`, `${stats.infortunioHours}h`, `${stats.reperibilitaHours}h`, `${oreEffettive}h`, saldoCell]],
    // Una colonna in più (Infortunio) rispetto a prima: fontSize ridotto leggermente
    // (7.5→7) per tenere l'intestazione più lunga ("Debito/Accredito") su una riga
    // sola invece di forzare un wrap che sposterebbe le altre colonne.
    styles: { fontSize: 7, cellPadding: 2, halign: 'center' },
    headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold', halign: 'center', fontSize: 6.5 },
    theme: 'grid',
  });
};

export const renderDayTable = (doc, dayRows) => {
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 8,
    head: [['Data', 'Giorno', 'Orario / Assenza', 'Ore lav.', 'Note', 'Stato']],
    body: dayRows,
    styles: { fontSize: 8.5, cellPadding: 2.5, overflow: 'linebreak' },
    headStyles: { fillColor: [52, 73, 94], textColor: 255, fontStyle: 'bold' },
    columnStyles: { 0: { cellWidth: 20 }, 1: { cellWidth: 25 }, 2: { cellWidth: 48 }, 3: { cellWidth: 20, halign: 'center' }, 4: { cellWidth: 46 }, 5: { cellWidth: 24 } },
    theme: 'striped',
    alternateRowStyles: { fillColor: [245, 248, 252] },
  });
};

const buildNightRows = (notteShifts) =>
  notteShifts.map(t => {
    const deduzione = calcDeduzioneNottePassiva(t);
    const intervalli = parseNotteAttivaIntervalli(t.notte_attiva_intervalli);
    const emStr = intervalli.length > 0 ? intervalli.map(iv => `${iv.inizio}–${iv.fine}`).join(', ') : '—';
    return [fmt(t.fullDate), italianWeekday(t.fullDate), `${(t.start_time || '?').substring(0, 5)}–${(t.end_time || '?').substring(0, 5)}`, fmtDuration(deduzione) || '—', emStr];
  });

export const renderNightSection = (doc, { uName, turniData, allDays, pageH }) => {
  const notteShifts = allDays.flatMap(d =>
    turniData.filter(t => t.operator_name === uName && t.date === d.fullDate && !ABSENCE_TYPES.includes(t.shift_type) && overlapsPassiveWindow(t)).map(t => ({ ...t, fullDate: d.fullDate }))
  );
  if (notteShifts.length === 0) return;
  if (doc.lastAutoTable.finalY + 30 > pageH) doc.addPage();
  const notteHeadingY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(9); doc.setFont('helvetica', 'bold'); doc.setTextColor(0);
  doc.text('Dettaglio notti (01:00–05:00)', 14, notteHeadingY);
  doc.setFont('helvetica', 'normal');
  autoTable(doc, {
    startY: notteHeadingY + 4,
    head: [['Data', 'Giorno', 'Orario', 'Passiva dedotta', 'Emergenze']],
    body: buildNightRows(notteShifts),
    styles: { fontSize: 8, cellPadding: 2.5, overflow: 'linebreak' },
    headStyles: { fillColor: [84, 110, 122], textColor: 255, fontStyle: 'bold' },
    columnStyles: { 0: { cellWidth: 20 }, 1: { cellWidth: 28 }, 2: { cellWidth: 30 }, 3: { cellWidth: 32, halign: 'center' }, 4: { cellWidth: 'auto' } },
    theme: 'striped',
    alternateRowStyles: { fillColor: [236, 240, 241] },
  });
};
